export const getErrorMessage = (value: any): string | null => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value) || (value && typeof value === 'object')) {
    const values = Array.isArray(value) ? value : Object.values(value);
    for (const entry of values) {
      const message = getErrorMessage(entry);
      if (message) return message;
    }
  }
  return null;
};

type ApiErrorResponse = Record<string, string | string[]>;

export const getApiErrorMessage = (
  error: ApiErrorResponse,
  fallback: string,
): string => {
  for (const key of Object.keys(error)) {
    const value = error[key];
    if (Array.isArray(value) && value.length > 0) {
      return value[0];
    }
    if (typeof value === 'string' && value) {
      return value;
    }
  }
  return fallback;
};
